import { useEffect, useState } from 'react';
import Intercom from './intercom';
import {
    Iinitialize,
    Ipublish,
    Isubscribe,
    IuseSubscribe,
    ShallowObj,
} from './types';

export const initialize: Iinitialize = (payload) => {
    Intercom.getInstance(payload);
};

export const publish: Ipublish = (eventName, payload) => {
    const IntercomInstance: Intercom = Intercom.getInstance();

    IntercomInstance.publish(eventName, payload);
};

export const subscribe: Isubscribe = (eventName, callback) => {
    const IntercomInstance: Intercom = Intercom.getInstance();

    return IntercomInstance.subscribe(eventName, callback);
};

export const useSubscribe: IuseSubscribe = (eventName) => {
    const [data, setData] = useState<ShallowObj>({});

    useEffect(() => {
        const [unsubscribe, initialStore] = subscribe(
            eventName,
            (updatedData) => {
                setData(updatedData);
            },
        );

        setData(initialStore);
        return unsubscribe;
    }, [data, setData, eventName]);

    return data;
};

export * from './types';
